import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css'; // core Swiper
import 'swiper/css/navigation'; // Navigation module
import 'swiper/css/pagination'; // Pagination module

type BlockContentItem = {
  id: number;
  icon: string;
  title: string;
  text: string;
  mob: string;
};

const WhyChoose: React.FC = () => {
  const blockContent: BlockContentItem[] = [
    // {
    //   id: 1,
    //   icon: '/featureIcons/certified.svg',
    //   title: "ATOL Protected",
    //   text: "High Standards and Dependable Service Tailored to Your Travel Desires",
    //   mob: "High standards and reliable service for your travel needs.",
    // },
    {
      id: 2,
      icon: '/featureIcons/discount.svg',
      title: "No Hidden Fees",
      text: "Absolutely No Hidden Fees – Full Transparency with Every Booking!",
      mob: "Transparent Pricing, No Surprises",
    },
    {
      id: 3,
      icon: '/featureIcons/booking.svg',
      title: "Flexible Cancellation Policies",
      text: "Cancel Anytime: Flexible Policies for Your Peace of Mind",
      mob: "Flexible Cancellations for Easy Changes",
    },
    {
      id: 4,
      icon: '/featureIcons/quote-request.svg',
      title: "Easy Payment Plan",
      text: "Effortless Payment Plans: Travel Now, Pay at Your Convenience",
      mob: "Simple Payment Options for Stress-Free Travel",
    },
    // Add more items as needed
  ];

  return (
    <div className="p-0 mt-5">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]} // Directly include modules
        spaceBetween={30}
        slidesPerView={3}
        pagination={{ clickable: true }}
        navigation={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false
        }}
        loop={false}
        breakpoints={{
          // when window width is >= 640px
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
      >
        {blockContent.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="featureIcon-type-1 rounded-lg text-center p-3 bg-white mb-6">
              <img
                src={item.icon}
                alt={item.title}
                className="w-12 h-12 md:w-10 md:h-10 mx-auto mb-3"
                loading="lazy"
              />
              <h3 className="text-[18px] font-medium text-gray-800">{item.title}</h3>
              <p className="text-[12px] text-gray-600">{item.text}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default WhyChoose;